import React from "react";
import "./BadgeDetailLoader.scss";

const BadgeDetailLoader = () => {
  return (
    <div className="badge-detail-container">
    <div className="steps-skeleton-container">
    <div className="steps-skeleton-card-container">
      <div className="skeleton-card-image skeleton"></div>
    </div>
  </div>
  </div>
  );
};

export default BadgeDetailLoader;
